import React from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
} from "mdb-react-ui-kit";

const Services = () => {
  return (
    <MDBContainer className="py-5">
      <MDBRow className="g-4">
        {/* Card 1 */}
        <MDBCol md="4">
          <MDBCard className="h-100 shadow">
            <MDBCardBody>
              <MDBCardTitle>Listing Services</MDBCardTitle>
              <h6 className="text-muted">Product Listing</h6>
              <MDBCardText>
                We manage and optimize your product listings across platforms to
                improve visibility and sales.
              </MDBCardText>
              <MDBBtn color="danger">Get Started</MDBBtn>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>

        {/* Card 2 */}
        <MDBCol md="4">
          <MDBCard className="h-100 shadow">
            <MDBCardBody>
              <MDBCardTitle>1/1 Warehouse Management</MDBCardTitle>
              <h6 className="text-muted">Inventory Control</h6>
              <MDBCardText>
                Complete warehouse management with real-time stock tracking and
                order handling.
              </MDBCardText>
              <MDBBtn color="danger">Learn More</MDBBtn>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>

        {/* Card 3 */}
        <MDBCol md="4">
          <MDBCard className="h-100 shadow">
            <MDBCardBody>
              <MDBCardTitle>Logistics Support</MDBCardTitle>
              <h6 className="text-muted">Fast Delivery</h6>
              <MDBCardText>
                End-to-end logistics support ensuring fast, secure, and reliable
                deliveries.
              </MDBCardText>
              <MDBBtn color="danger">Contact Us</MDBBtn>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default Services;
